import request from '@/utils/request'

// 할인정보 리스트 조회
export function getDiscountList (params, isNotify) {
  return request({
    url: `/api/getDiscountList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}


// 요금제에 적용가능한 할인정보 리스트 조회
export function getDiscountListByFee (params, isNotify) {
  return request({
    url: `/api/getDiscountListByFee`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 할인 정보 저장
export function saveDiscountData (params, isNotify) {
  return request({
    url: `/api/saveDiscountData`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}